import * as React from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import colorSchemes from "../../../constants/colorSchemes";
import routes from "../../../constants/routes";
import useStyles from "./Forgot.styles";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import forgotPasswordAPI from "../../../api/forgotPasswordAPI";
import { setToken, removeToken, removeUserData, getToken, setUserData,getUserData } from "../../../common";
import LogoutIcon from "@mui/icons-material/Logout";
import { isEmpty } from "lodash";
import Loader from '../../../common/Loader';

export default function Forgot() {
  const navigate = useNavigate();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);

  const [loginInfo, setLoginInfo] = useState({
    email: ""
  });
  const userData = getUserData() ?? {};
  //---------------------------- login-Process ----------------------------------

  const handleChange = (event) => {
    setLoginInfo({ ...loginInfo, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      setIsLoading(true)
      const { data } = await forgotPasswordAPI(loginInfo);
      

      if(data){
        toast(data.message);
        setIsLoading(false)    
        setTimeout(() => {
          navigate(routes.verification, { state: { data: loginInfo.email } });
        }, 1500);
      }

    } catch (error) {
      if (error.response) {
        //console.log(error.response.data.error);
        toast(error.response.data.error);
        setIsLoading(false) 
      } else if (error.request) {
        toast("Something Went Wrong!");
        setIsLoading(false) 
      } else {
        //console.log('Error', error.message.code);
        setIsLoading(false) 
      }
      
    }

   //setUserInfo({ email: "", firstname: "", lastname: "", phonenumber: "" , password: "", confirmpassword: ""});
  };
 

  return (
    <>
    {isLoading === true && <Loader isLoading={isLoading} /> }
    <Box className={classes.signin}>
      {isEmpty(userData) ? 
        <Card
          sx={{ maxWidth: 500, marginTop: "9em", padding: "1em 2em" }}
          className={classes.signcard}
        >
        
          <Box>
            <Typography
              sx={{
                textAlign: "center",
                fontWeight: "600",
                color: colorSchemes.primaryColor,
              }}
              variant="h5"
            >
              FORGOT PASSWORD
            </Typography>
          </Box>
          <form
            layout="vertical"
            onSubmit={handleSubmit}
          >
            <Box className={classes.forms}>             
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label className={classes.label}>E-mail</Form.Label>
                <Form.Control
                  className={classes.input}
                  type="email"
                  placeholder="Enter email"
                  name="email"
                  value={loginInfo.email}
                  onChange={handleChange}
                />
              </Form.Group>
            </Box>                   
            <Box>
              <Button
                sx={{
                  backgroundColor: colorSchemes.primaryColor,
                  color: "#fff",
                  borderRadius: "0em",
                  "&.MuiButtonBase-root:hover": {
                    bgcolor: "#2D55EB !important",
                  },
                }}
                // onClick={() => {
                //   setToken(loginInfo.email);
                //   navigate(routes.home);
                // }}
                fullWidth
                type="submit"
              >
                Login
              </Button>
            </Box>
          </form>
          <Typography className={classes.forgot}
          sx={{
            textAlign: "center",
          }}>
           <Link to="/sign-in">Back To Login</Link>{" "}
          </Typography>
        </Card>
      : <Card
          sx={{ maxWidth: 500, marginTop: "9em", padding: "1em 2em" }}
          className={classes.signcard}
        >
          <center>
          <h3>Your Already Logged in!</h3>
          <Button
              sx={{
                backgroundColor: colorSchemes.primaryColor,
                color: "#fff",
                borderRadius: "0em",
                "&.MuiButtonBase-root:hover": {
                  bgcolor: "#2D55EB !important",
                },
              }}
              onClick={() => {
                removeToken();
                removeUserData();
                navigate(routes.signin);
              }}
              fullWidth
              type="submit"
            >
              <LogoutIcon
                  sx={{
                    color: "white",
                    fontSize: "16px",
                    marginTop: "-2px",
                    marginRight: "5px",
                  }}
                />
              Log Out
            </Button>
          </center>
      </Card>}
    </Box>
    </>
  );
}
